<template>
    <div class="orgstructure-content">
        <div class="orgstructure-tree">
        <ai-tree-list-edit
            ref="treeViewRef"
            :meta="meta"
            :args="args"
        >
        </ai-tree-list-edit>
        </div>
        <div class="orgstructure-card">
            <component :is="componentCardName" ref="cardRef" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'org-structure-tree',
};
</script>

<script setup>
import { /*computed,*/ ref, onMounted, /*, nextTick*/ } from 'vue';
//import localTreeView from '@/components/local-tree-view.vue';
//import { getCookie, setCookie } from '@/utils/cookies';
//import { getDepartmentsStartList } from '@/service/admin-service';
//import { getNsiOrgstructureTreeviewData } from '@/service/nsi-service';
import router from '@/router';

const treeViewRef = ref();
const treeViewInstance = ref();
//const departmentList = ref([]);
//const formData = inject('formData');
//const selectedDeps = ref(new Map());
const componentCardName = ref(null);
const cardRef = ref();

const str_where = 'pr_active = 0';

//const cardName = computed(() => componentCardName.value);

onMounted(async () => {
    treeViewInstance.value = treeViewRef.value?.treeListInstance;
    treeViewInstance.value.on('focusedRowChanged', onItemClick);
    treeViewInstance.value.option('showRowLines', false);
    treeViewInstance.value.on('rowInserted', onRowInsert);
});

window.onblur = function () {
    if (treeViewRef.value) treeViewInstance.value?.option('focusedElement', '');
};

const onItemClick = event => {
    setTimeout(async () => {
        if (event.row) {
            if (event.row.data.e === 'KR_ORG') {
                componentCardName.value = null;
                setTimeout(async () => {
                    await router.push({
                        name: 'org-structure-org',
                        params: {
                            app: router.currentRoute.value.params.app,
                            dep: router.currentRoute.value.params.dep,
                            id: event.row.data.id
                        },
                    });
                    componentCardName.value = 'nsi-org-card';
                }, 500);
            } else if (event.row.data.e === 'KR_EMPLOYEE') {
                componentCardName.value = null;
                setTimeout(async () => {
                    await router.push({
                        name: 'org-structure-emp',
                        params: {
                            app: router.currentRoute.value.params.app,
                            dep: router.currentRoute.value.params.dep,
                            id: event.row.data.id
                        },
                    });
                    componentCardName.value = 'nsi-emp-card';
                }, 500);
            }
        }
    }, 500);

    //console.log('componentCardName.value ', componentCardName.value);

    //treeViewInstance.value.selectItem(event.row.data.id_t);

};

const onRowInsert = event => {
    alert('NewRow');
    console.log('NewRow ', event);
}

/*
const onAddEmployeeButton = async () => {
    alert('AddEmployee');
}
*/

const meta = {
    searchHint: null,
    keyExpr: 'id_t',
    displayExpr: 'name',
    parentIdExpr: 'parent_id_t',
    dataStructure: 'plain',
    rootValue: null,
    selectByClick: true,
    selectionMode: 'single',
    expandEvent: 'dbclick',
    itemTemplate: 'item',
    valueChangeEvent: 'keyup',
    animationEnabled: false,
    expandAll: true,
    firstColumnFields: {
        text: 'name',
        svg: 'img_src',
        caption: 'Наименование',
        allowEditing: false,
    },
    columns: [
        {
            dataField: 'id',
            allowEditing: false,
            visible: false,
        },
        /*{
            dataField: 'img_src',
            allowEditing: false,
        },*/
    ],
    api: {
        // select: 'meta./meta/ai-tree-list-edit/select/get',
        select: 'admin./department/official/tree/get',
        //save: 'e-grid./eoschema/set',
        // save: 'meta./meta/ai-tree-list-edit/save/set',
    },
};
const args = {
    select: {
        meta_args: {
            select: 'admin.get_orgstructure_tree',
        },
        select_args: {
            str_where: str_where,
        },
    },
};


</script>
<style>
.orgstructure-content {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    padding: 5px 5px 0 5px;
}

.orgstructure-tree {
    display: flex;
    height: 100%;
    flex-basis: 30%;
}

.orgstructure-card {
    display: flex;
    height: 100%;
    flex-basis: 70%;
}


</style>
